import * as React from 'react';
import { IAdvantageClaimsDisabilityType, IAdvantageClaimsDisabilityTypeState } from './AdvantageClaimsDisabilityTypes';
import { IChildrenProps } from 'types/children';

export const AdvantageClaimsDisabilityContext = React.createContext<IAdvantageClaimsDisabilityTypeState | null>(null);

const AdvantageClaimsDisabilityProvider: React.FC<IChildrenProps> = ({ children }) => {
    const initialState: IAdvantageClaimsDisabilityType = {
        borrowerNameFirst: '',
        borrowerNameLast: '',
        borrowerMailingAddress: '',
        borrowerMailingCity: '',
        borrowerMailingState: undefined,
        borrowerMailingZip: '',
        borrowerEmail: '',
        borrowerPhone: '',
        borrowerSSN: '',
        borrowerDateOfBirth: '',
        borrowerComments: '',
        employerName: '',
        employerEmail: '',
        employerContactNumber: '',
        employerAddress: '',
        employerCity: '',
        employerState: undefined,
        employerZip: '',
        disabilityHealthcareName: '',
        disabilityHealthcareHospitalName: '',
        disabilityHealthcareContactNumber: '',
        disabilityDateOfIncident: '',
        disabilityExplanationOf: '',
        disabilityTypeOfSurgery: '',
        disabilityDateLastWorked: '',
        disabilityKnowWhenExpectedWorking: '',
        disabilityDateExpectedWorking: '',
        disabilityHealthcareAddress: '',
        disabilityHealthcareCity: '',
        disabilityHealthcareState: undefined,
        disabilityHealthcareZip: '',
        disabilityFirstPhysicianDate: '',
        disabilityJobDuties: '',
        disabilityFiledOnBehalfOf: undefined,
        submitterCompanyName: '',
        submitterNameFirst: '',
        submitterNameLast: '',
        submitterEmail: '',
        submitterPhone: '',
        eDeliveryConfirmation: ''
    };
    const [stateAdvantageClaimsDisability, setStateAdvantageClaimsDisability] =
        React.useState<IAdvantageClaimsDisabilityType>(initialState);
    const saveState = (formData: IAdvantageClaimsDisabilityType): void => {
        setStateAdvantageClaimsDisability({ ...formData });
    };
    const reinitialise = (): void => {
        setStateAdvantageClaimsDisability(initialState);
    };

    return (
        <AdvantageClaimsDisabilityContext.Provider
            value={{
                contextStateAdvantageClaimsDisability: stateAdvantageClaimsDisability,
                updateContextStateAdvantageClaimsDisability: saveState,
                reinitialiseContextStateAdvantageClaimsDisability: reinitialise
            }}
        >
            {children}
        </AdvantageClaimsDisabilityContext.Provider>
    );
};

export default AdvantageClaimsDisabilityProvider;
